import getters from './getters';
import mutations from './mutations';

const state = {
  menuActive: false,
  mobileShowAvailability: false,
  window: {
    innerWidth: 0
  },
  pageReady: false,
  isIdle: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ui/index.js